import React from 'react';
import propTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';
import classnames from 'classnames';

import styles from './Switch.css';

/**
 * render an array of values as inline radio buttons
 * @param {object} props - props passed to the component
 * @returns {React.Component} - Switch canvas widget
 */
const Switch = ({ fieldContract: { allowedValues = [] }, onChange, selectedValue }) => {
  return (
    <div className="d-flex flex-column my-3">
      <FormGroup check inline>
        {allowedValues.map((displayName, ind) => {
          const isActive = selectedValue === ind || selectedValue === displayName;
          return (
            <Label
              key={displayName}
              className={classnames([styles.labelText, { [styles.active]: isActive }, 'mr-3'])}
              check
            >
              <Input
                className={styles.input}
                type="radio"
                checked={isActive}
                onChange={() => onChange(ind)}
              />
              {displayName}
            </Label>
          );
        })}
      </FormGroup>
    </div>
  );
};

Switch.propTypes = {
  fieldContract: propTypes.shape({
    allowedValues: propTypes.arrayOf(propTypes.string),
    helpText: propTypes.string,
    name: propTypes.string,
    required: propTypes.bool
  }).isRequired,
  onChange: propTypes.func.isRequired,
  selectedValue: propTypes.oneOfType([propTypes.number, propTypes.string]).isRequired
};

export default Switch;
